import React from "react";
import CustomerImg from "/public/assets/img/customer.png";
import QualityImg from "/public/assets/img/quality.png";
import ClientImg from "/public/assets/img/client.png";
import AfterSaleImg from "/public/assets/img/after.png";
import CommitmentImg from "/public/assets/img/Commitment.png";
import QualityAssuranceImg from "/public/assets/img/QualityAssurance.png";

/* ---------------- Image Mapping ---------------- */
const imageMap = {
  customerCare: CustomerImg,
  qualityPolicy: QualityImg,
  clientSatisfaction: ClientImg,
  afterSales: AfterSaleImg,
  commitmentQuality: CommitmentImg,
  qualityAssurance: QualityAssuranceImg,
};

/* ---------------- Reusable Section ---------------- */
const Section = ({
  heading,
  subHeading,
  children,
  imageKey,
  imageAlt,
  showDivider = true,
}) => {
  return (
    <>
      <h2 className="fw-bold mb-2">{heading}</h2>

      <div className="row align-items-center mb-5">
        <div className="col-md-7">
          <h4 className="fw-semibold mb-3">{subHeading}</h4>
          {children}
        </div>

        <div className="col-md-5 text-center">
          <div className="border rounded p-3 bg-light">
            <img
              src={imageMap[imageKey]}
              alt={imageAlt}
              className="img-fluid"
              loading="lazy"
            />
          </div>
        </div>
      </div>

      {showDivider && <hr className="my-5 opacity-25" />}
    </>
  );
};

/* ---------------- Main Component ---------------- */
const QualityCompliance = () => {
  return (
    <section className="container py-5 mt-5">
      {/* ================= Customer Care ================= */}
      <Section
        heading="Quality & Compliance"
        subHeading="Customer Care"
        imageKey="customerCare"
        imageAlt="LubriChem Customer Care"
      >
        <p>
          At <strong>LubriChem Oils Pvt. Ltd.</strong>, we believe that strong
          relationships are built on trust, support, and service.
        </p>

        <ul>
          <li>
            <strong>Quick Response</strong> – Fast handling of inquiries.
          </li>
          <li>
            <strong>Technical Guidance</strong> – Expert product advice.
          </li>
          <li>
            <strong>After-Sales Support</strong> – Continuous assistance.
          </li>
          <li>
            <strong>Feedback & Improvement</strong> – Client engagement.
          </li>
          <li>
            <strong>24/7 Assistance</strong> – For urgent requirements.
          </li>
        </ul>
      </Section>

      {/* ================= Quality Policy ================= */}
      <Section
        heading="Quality Policy"
        subHeading="Quality Policy"
        imageKey="qualityPolicy"
        imageAlt="Quality Policy"
      >
        <p>
          We are committed to delivering products that meet international
          quality standards.
        </p>

        <ul>
          <li>
            <strong>Customer Focus</strong>
          </li>
          <li>
            <strong>Regulatory Compliance</strong>
          </li>
          <li>
            <strong>Continuous Improvement</strong>
          </li>
          <li>
            <strong>Employee Involvement</strong>
          </li>
          <li>
            <strong>Sustainability</strong>
          </li>
        </ul>
      </Section>

      {/* ================= Client Satisfaction ================= */}
      <Section
        heading="Client Satisfaction"
        subHeading="Client Satisfaction"
        imageKey="clientSatisfaction"
        imageAlt="Client Satisfaction"
      >
        <ul>
          <li>
            <strong>Quality Assurance</strong>
          </li>
          <li>
            <strong>Customized Solutions</strong>
          </li>
          <li>
            <strong>Timely Delivery</strong>
          </li>
          <li>
            <strong>Responsive Support</strong>
          </li>
          <li>
            <strong>Continuous Feedback</strong>
          </li>
        </ul>
      </Section>

      {/* ================= After Sales Service ================= */}
      <Section
        heading="After Sales Service"
        subHeading="After Sales & Service"
        imageKey="afterSales"
        imageAlt="After Sales Service"
      >
        <ul>
          <li>
            <strong>Technical Assistance</strong>
          </li>
          <li>
            <strong>Customer Support</strong>
          </li>
          <li>
            <strong>On-Site Support</strong>
          </li>
          <li>
            <strong>Continuous Improvement</strong>
          </li>
          <li>
            <strong>Training & Awareness</strong>
          </li>
        </ul>
      </Section>

      {/* ================= Commitment To Quality ================= */}
      <Section
        heading="Commitment To Quality"
        subHeading="Commitment to Quality"
        imageKey="commitmentQuality"
        imageAlt="Commitment To Quality"
      >
        <ul>
          <li>
            <strong>Stringent Quality Control</strong>
          </li>
          <li>
            <strong>Certified Systems</strong>
          </li>
          <li>
            <strong>High-Grade Raw Materials</strong>
          </li>
          <li>
            <strong>Continuous Improvement</strong>
          </li>
          <li>
            <strong>Customer-Centric Focus</strong>
          </li>
        </ul>
      </Section>

      {/* ================= Quality Assurance ================= */}
      <Section
        heading="Quality Assurance"
        subHeading="Quality Assurance"
        imageKey="qualityAssurance"
        imageAlt="Quality Assurance"
        showDivider={false}
      >
        <ul>
          <li>
            <strong>Stringent Testing</strong>
          </li>
          <li>
            <strong>ISO 9001:2015 Compliance</strong>
          </li>
          <li>
            <strong>High-Grade Inputs</strong>
          </li>
          <li>
            <strong>Process Control</strong>
          </li>
          <li>
            <strong>Documentation & Traceability</strong>
          </li>
          <li>
            <strong>Continuous Training</strong>
          </li>
        </ul>
      </Section>
    </section>
  );
};

export default QualityCompliance;
